import styled from 'styled-components';
import { colors } from '../../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-width: 460px;

  background-color: ${colors.surfaceContainerLow};

  @media (max-width: 1199px) {
    min-width: auto;
  }
`;

export const Content = styled.div`
  padding: 28px;
`;

export const Title = styled.h2`
  font-size: 22px;
  margin: 15px 0;
  font-weight: 700;
  color: ${colors.onSurface};

  span {
    color: ${colors.primary};
  }

  @media (max-width: 1199px) {
    font-size: 18px;
  }
`;

export const PaymentMethods = styled.div``;
